import React, { Fragment } from 'react';

//Components
import Input from '../../../../common/form/new/Input';
import { RenderNameComponent, RenderDOBComponent } from './renderCommonSearchComponents';

//Constants
import { INPUT_TYPES } from '../../../../common/form/constants/fieldTypes';



export const RenderSearchByNameComponents = ({ values, handleChange, handleBlur, handleFocus }) => {

    return(
        <Fragment>
            <div className="grid-row grid-gap-lg margin-t-10">
                <RenderNameComponent { ...{ values, handleChange, handleBlur, handleFocus, readOnly: true }} />
                <RenderDOBComponent { ...{ values, handleChange, handleBlur, handleFocus, readOnly: true }} />
            </div>
            <div className="grid-row grid-gap-lg margin-t-20">
                <Input
                    label={{
                        labelText:'label.email',
                        labelClasses: ['gi-input__label--col', 'grid-col-12'],
                        wrapperClasses: ['gi-input--col', 'grid-col-4'],
                        isRequired: true
                    }}
                    input={{
                        id: 'email',
                        name: 'email',
                        inputClasses: ['grid-col-12'],
                        type: INPUT_TYPES.EMAIL,
                        value: values.email,
                        maxLength: 60,
                        isInputRequired: true
                    }}
                    actions={{
                        handleFieldChange: value => handleChange({ target: { value, name:'email' } }),
                        handleFieldBlur: value => handleBlur({ target: { value, name:'email' } }),
                        handleFieldFocus: value => handleFocus({ target: { value, name:'email' } })
                    }}
                />

                <Input
                    label={{
                        labelText:'label.zip_code',
                        labelClasses: ['gi-input__label--col', 'grid-col-12'],
                        wrapperClasses: ['gi-input--col', 'grid-col-4'],
                        isRequired: true
                    }}
                    input={{
                        id: 'zipCode',
                        name: 'zipCode',
                        inputClasses: ['grid-col-12'],
                        type: INPUT_TYPES.TEXT,
                        value: values.zipCode,
                        maxLength: 5,
                        isInputRequired: true
                    }}
                    actions={{
                        handleFieldChange: value => handleChange({ target: { value, name:'zipCode' } }),
                        handleFieldBlur: value => handleBlur({ target: { value, name:'zipCode' } }),
                        handleFieldFocus: value => handleFocus({ target: { value, name:'zipCode' } })
                    }}
                />
                <Input
                    label={{
                        labelText:'label.city',
                        labelClasses: ['gi-input__label--col', 'grid-col-12'],
                        wrapperClasses: ['gi-input--col', 'grid-col-4'],
                        isRequired: true
                    }}
                    input={{
                        id: 'city',
                        name: 'city',
                        inputClasses: ['grid-col-12'],
                        type: INPUT_TYPES.TEXT,
                        value: values.city,
                        isInputRequired: true
                    }}
                    actions={{
                        handleFieldChange: value => handleChange({ target: { value, name:'city' } }),
                        handleFieldBlur: value => handleBlur({ target: { value, name:'city' } }),
                        handleFieldFocus: value => handleFocus({ target: { value, name:'city' } })
                    }}
                />
            </div>
        </Fragment>
    );

};